import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { PlanSection } from "@/features/billing/components/PlanSection";
import { SubscriptionSection } from "@/features/billing/components/SubscriptionSection";
import { InvoicesSection } from "@/features/billing/components/InvoicesSection";

export function SubscriptionPage() {
  const { t } = useTranslation();

  return (
    <div className="max-w-2xl">
      <PageHeader title={t("nav.subscription")} subtitle={t("billing.subtitle")} />
      <PlanSection />
      <SubscriptionSection />
      <InvoicesSection />
    </div>
  );
}
